import _ from "lodash";
import moment from "moment";
import { toString } from "../core/core";
import * as dateUtil from "../core/dateTime";
import { ll } from "../core/ll";
import { user } from "../core/user";

function customTextRefresh(e, binding) {
    var me = this;
    binding = binding || "customText";

    var value = me.bindings[binding].get(),
        originalValue = value;

    if (value != null && typeof value != "string") {
        value = $.trim(value.toString());
    }

    var element = me.element;
    var dateFormat;
    if ($(element).data("zData")) {
        dateFormat = $(me.element).data("zData").DateFormat;
    }

    var path = me.bindings[binding].path.toLowerCase();

    if (!dateFormat) {
        if (path.indexOf("udf_") == 0) {
            var theElement = element.element || element;
            var elementId = $(theElement).attr("id");
            var splitOnUnderscores = elementId.split("_");
            var tableName = splitOnUnderscores[0].substring(0, splitOnUnderscores[0].length - 2);
            var userDefinedField = _.find(user.companyData.UserDefinedFields, function (a) {
                return a.BindName.toLowerCase() == path && a.TableName == tableName;
            });
            if (userDefinedField.Type == "DATE") {
                dateFormat = "Date";
            } else if (userDefinedField.Type == "TIME") {
                dateFormat = "Time";
            } else if (userDefinedField.Type == "DATETIME") {
                dateFormat = "DateTime";
            }
        } else {
            if (path.indexOf("date") != -1 && path.indexOf("time") != -1) {
                dateFormat = "DateTime";
            } else if (path.indexOf("date") != -1) {
                dateFormat = "Date";
            } else if (path.indexOf("time") != -1) {
                dateFormat = "Time";
            }
        }
    }

    if (!value || (value.match && value.match(/^ *$/) !== null)) {
        if (dateFormat && dateFormat.indexOf("Date") != -1 && dateFormat.indexOf("Time") != -1) {
            value = "--/--/----  --:--";
        } else if (dateFormat && dateFormat.indexOf("Date") != -1) {
            value = "--/--/----";
        } else if (dateFormat && dateFormat.indexOf("Time") != -1) {
            value = "--:--";
        } else {
            value = "---";
        }
    } else if (dateFormat == "DateTime") {
        value = dateUtil.kendoFormatDateTime(value);
    } else if (dateFormat == "Date") {
        if (Object.prototype.toString.call(originalValue) == "[object Date]") {
            value = dateUtil.kendoFormatDate(originalValue);
        } else {
            value = dateUtil.kendoFormatDate(value);
        }
    } else if (dateFormat == "Time") {
        value = dateUtil.kendoFormatTime(value);
    }

    if (element.element) {
        element = element.element;
        if (me.element.dataSource) {
            $.each(me.element.dataSource._data, function (index, data) {
                if (data.Id == value) {
                    value = data.Value;
                }
            });
        }
        var elem = $(me.element)[0] as any;
        if (elem.options && elem.options.format) {
            var format = elem.options.format;
            var decimal = elem.options.decimals;
            if (value != "---" && decimal > 0) {
                value = toString(parseFloat(value), format);
            }
        }
        me.element.input && me.element.input.val(value);
        me.element._text && me.element._text.val && me.element._text.val(value);

    }

    $(element).text(value);
    $(element).val(value);

    $(document.body).append("<div id='Sizer'></div>");

    var sizer = $("#Sizer");
    element = $(element);
    var min = 10;

    sizer.text(value);

    element.css("font-size", "");
    var size = parseInt(element.css("font-size"), 10);
    sizer.css("font-size", size);

    while (sizer.width() > element.width() && element.width() > 0 && size > min) {
        size--;
        sizer.css("font-size", size);
    }

    $(element).css("font-size", size);

    sizer.remove();
}

function customTextAndTooltipRefresh() {

    var me = this,
        element = me.element,
        value = me.bindings.customTextAndTooltip.get();
    if (element.element) {
        element = element.element;
        if (me.element.dataSource) {
            $.each(me.element.dataSource._data, function (index, data) {
                if (data.Id == value) {
                    value = data.Value;
                }
            });
        }
        me.element.input && me.element.input.val(value);
        me.element._text && me.element._text.val && me.element._text.val(value);
    }

    customTextRefresh.apply(this, [null, "customTextAndTooltip"]);

    if (value) {
        $(element).attr("title", value);
    }
}

// Custom Text can be used to display "---" when the value is null or empty
const customTextBinder = kendo.data.Binder.extend({
    refresh: customTextRefresh
});

const customTextAndTooltipBinder = kendo.data.Binder.extend({
    refresh: customTextAndTooltipRefresh
});

const booleanTextBinder = kendo.data.Binder.extend({
    refresh: function () {
        var value = this.bindings.booleanText.get(),
            text = ll("Yes");

        if (!value || value == "false") {
            text = ll("No");
        }

        $(this.element).text(text);
        $(this.element).val(text);
    }
});

const currencyBinder = kendo.data.Binder.extend({
    refresh: function () {
        var value = this.bindings.currency.get();

        value = toString(value, "c2");

        $(this.element).text(value);
        $(this.element).val(value);
    }
});

const percentageBinder = kendo.data.Binder.extend({
    refresh: function () {
        var value = this.bindings.percentage.get();

        value = toString(value / 100, "p2");

        $(this.element).text(value);
        $(this.element).val(value);
    }
});

const countTextBinder = kendo.data.Binder.extend({
    refresh: function () {
        var value = this.bindings.countText.get();

        if (value != null && typeof value != "string") {
            value = value.toString();
        }

        if (!value || (value.match && value.match(/^ *$/) !== null)) {
            value = "0";
        }

        $(this.element).text(value);
        $(this.element).val(value);
    }
});

const durationFromHoursBinder = kendo.data.Binder.extend({
    refresh: function () {
        var hours = this.bindings.durationFromHours.get();
        var value = dateUtil.formatDurationFromHours(hours);
        $(this.element).text(value);
    }
});

// Custom Text can be used to display "---" when the value is null or empty
const durationTimerBinder = kendo.data.Binder.extend({
    refresh: function () {
        var seconds = this.bindings.durationTimer.get();

        var showdur = dateUtil.buildTimeString(null);

        $(this.element).text(showdur);
    }
});

// bind tooltips to objects
const tooltipBinder = kendo.data.Binder.extend({
    refresh: function () {
        var value = this.bindings.tooltip.get();
        var tooltip = this.element;
        if (!value || value.match(/^ *$/) !== null) {
            $(tooltip).removeAttr("title");
        } else {
            $(tooltip).attr("title", value);
        }
    }
});

const localizedTextBinder = kendo.data.Binder.extend({
    refresh: function () {
        var binding = this.bindings.localizedText;
        var source;

        if (binding) {
            source = binding.source;

            var attrs = binding.path.split(".");
            $.each(attrs, function (index, value) {
                source = source[value];
            });
        } else {
            binding = this.bindings.ll;
            source = binding.path;
        }

        var text = ll(source);

        var mainObjectData = $("#" + $(this.element).data("labelForId")).data("me") || $(this.element).data("me");

        if (mainObjectData && mainObjectData.options && mainObjectData.options.screenEntityType) {
            text = ll(mainObjectData.options.screenEntityType + "." + source);
        }

        $(this.element).text(text);
        $(this.element).val(text);
    }
});

var runMeOnce = [];
var zDateChanged;
function dateTimeRefresh() {
    var value = this.bindings.dateTime.get() || null,
        newValue = null;

    if (runMeOnce.indexOf(this.bindings.dateTime.path) != -1) {
        runMeOnce.splice(runMeOnce.indexOf(this.bindings.dateTime.path));
        return;
    }

    runMeOnce.push(this.bindings.dateTime.path);

    if (zDateChanged) {
        runMeOnce.splice(runMeOnce.indexOf(this.bindings.dateTime.path));
        zDateChanged = false;
    }

    var dateFormat = "";
    if (this.options.id) {
        var zData = $("#" + this.options.id).data("zData");
        if (zData) {
            dateFormat = zData.DateFormat;
        }
        if (!dateFormat) {
            var binder = $("#" + this.options.id).data("me");
            if (binder) {
                dateFormat = binder.options.type;
            }
        }
    }

    if (dateFormat == "Date" || dateFormat == "DateInput") {
        newValue = dateUtil.buildDateString(value);
    } else if (dateFormat == "Time" || dateFormat == "TimeInput") {
        newValue = dateUtil.buildTimeString(value);
    } else {
        newValue = dateUtil.buildDateTimeString(value);
    }

    var element = this.element;
    if (element.element) {
        element = element.element;
    }

    var jqueryElement = $(element);
    var date = new Date(value);
    var today = new Date();

    // Work around for kendo saving the previous value and the change event not firing when you click the previously selected value
    var kendoTimePicker = jqueryElement.data("kendoTimePicker") as any;
    if (kendoTimePicker) {
        if (value) {
            kendoTimePicker._old = date;
            kendoTimePicker._value = date;
            kendoTimePicker._oldText = newValue;
            if (kendoTimePicker.timeView) {
                kendoTimePicker.timeView._value = new Date(value);
            }
        } else {
            kendoTimePicker._old = null;
            kendoTimePicker._value = null;
            kendoTimePicker._oldText = "";
            if (kendoTimePicker.timeView) {
                kendoTimePicker.timeView._value = null;
            }
        }
    }

    jqueryElement.text(newValue);
    jqueryElement.val(newValue);

    $.wait(10).then(function () {
        jqueryElement.text(newValue);
        jqueryElement.val(newValue);
    });
}

const widgetDateTimeBinder = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        var me = this;
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        $(this.element.element).data("kendoDateTimePicker").unbind("change").bind("change", function () {
            me.change();
        });
    },
    refresh: function () {
        var value = this.bindings.dateTime.get();

        if (value) {
            var dateTime = moment(value);
            $(this.element.element).data("kendoDateTimePicker").value(dateTime.toDate());
        } else {
            $(this.element.element).data("kendoDateTimePicker").value(null);
        }
    },
    change: function () {
        var element = this.element.element;
        var path = this.bindings.dateTime.path;
        var source = this.bindings.dateTime.source;

        if (source == "") {
            return;
        }

        var value = $(element).val();
        // See if kendo can parse the date as either the date + time, date, or time, otherwise set the value to null
        value = kendo.parseDate(value, [kendo.culture().calendar.patterns.g, kendo.culture().calendar.patterns.d, kendo.culture().calendar.patterns.t]);
        if (value) {
            source.set(path, value.toISOString());
            $(this.element.element).data("kendoDateTimePicker").value(value);
        } else {
            source.set(path, null);
            $(this.element.element).data("kendoDateTimePicker").value(null);
        }
    }
});

const timeBinder = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        var me = this;
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        $(this.element.element).unbind("change.bindTime").bind("change.bindTime", function () {
            $.wait(20).then(function () {
                me.change();
            });
        });
    },
    refresh: function () {
        var value = this.bindings.time.get();

        if (value) {
            var dateTime = moment(value);
            dateTime.toDate().setFullYear(1970, 0, 1);

            $(this.element.element).data("kendoTimePicker").value(dateTime.toDate());
        } else {
            $(this.element.element).data("kendoTimePicker").value(null);
        }
    },
    change: function () {
        var element = this.element.element;
        var path = this.bindings.time.path;
        var source = this.bindings.time.source;

        if (source == "") {
            return;
        }

        var value = $(element).val();
        var valid = moment(value, dateUtil.convertKendoTimeFormatToMoment(kendo.culture().calendar.patterns.t)).isValid();
        if (valid) {
            var dateTime = moment(value, dateUtil.convertKendoTimeFormatToMoment(kendo.culture().calendar.patterns.t)).toDate();
            dateTime.setFullYear(1970, 0, 1);
            source.set(path, dateTime.toISOString());
            $(this.element.element).data("kendoTimePicker").value(dateTime);
        } else {
            source.set(path, null);
            $(this.element.element).data("kendoTimePicker").value(null);
        }
    }
});

const absoluteTimeBinder = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        var me = this;
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        $(this.element.element).unbind("change.bindTime").bind("change.bindTime", function () {
            $.wait(20).then(function () {
                me.change();
            });
        });
    },
    refresh: function () {
        var value = this.bindings.absoluteTime.get();

        if (value) {
            var dateTime = moment(value);
            var theDate = dateTime.toDate();
            theDate.setFullYear(1970, 0, 1);
            theDate.setHours(value.substring(11, 13));
            theDate.setMinutes(value.substring(14, 16));

            $(this.element.element).data("kendoTimePicker").value(theDate);
        } else {
            $(this.element.element).data("kendoTimePicker").value(null);
        }
    },
    change: function () {
        var element = this.element.element;
        var path = this.bindings.absoluteTime.path;
        var source = this.bindings.absoluteTime.source;

        if (source == "") {
            return;
        }

        var value = $(element).val();
        var valid = moment(value, dateUtil.convertKendoTimeFormatToMoment(kendo.culture().calendar.patterns.t)).isValid();
        if (valid) {
            var dateTime = moment(value, dateUtil.convertKendoTimeFormatToMoment(kendo.culture().calendar.patterns.t)).toDate();
            var isoString = "1970-01-01T" + dateUtil.zeroPad(dateTime.getHours().toString(), 2) + ":" + dateUtil.zeroPad(dateTime.getMinutes().toString(), 2) + ":00.000Z";
            dateTime.setFullYear(1970, 0, 1);
            source.set(path, isoString);
            $(this.element.element).data("kendoTimePicker").value(dateTime);
        } else {
            source.set(path, null);
            $(this.element.element).data("kendoTimePicker").value(null);
        }
    }
});

const dateTimeBinder = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        var binder = this;

        // call the base constructor
        kendo.data.Binder.fn.init.call(binder, element, bindings, options);

        if (element.element) {
            element = element.element;
        }

        // listen for the change event of the element
        $(element).bind("change.bindDateTime", function () {
            if (binder) {
                var source = binder.bindings.dateTime.source,
                    path = binder.bindings.dateTime.path,
                    value = "";

                if (binder.element && binder.element.element) {
                    value = $(binder.element.element).val();
                } else {
                    value = $(binder.element).val();
                }

                value = dateUtil.buildDateTimeString(value);
                if ($.trim(value) == "") {
                    value = undefined;
                }
                source.set(path, value);
            }
        });
    },
    refresh: dateTimeRefresh
});

const dateBinder = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        var me = this;
        kendo.data.Binder.fn.init.call(this, element, bindings, options);

        $(this.element.element).unbind("change.bindDate").bind("change.bindDate", function () {
            $.wait(20).then(function () {
                me.change();
            });
        });
    },
    refresh: function () {
        var value = this.bindings.date.get();

        if (value) {
            value = value.substring(0, 10);
            var dateTime = moment(value);

            $(this.element.element).data("kendoDatePicker").value(dateTime.toDate());
        } else {
            $(this.element.element).data("kendoDatePicker").value(null);
        }
    },
    change: function () {
        var element = this.element.element;
        var path = this.bindings.date.path;
        var source = this.bindings.date.source;

        if (source == "") {
            return;
        }

        var value = $(element).val();
        value = kendo.parseDate(value, kendo.culture().calendar.patterns.d);
        if (value) {
            source.set(path, kendo.toString(value, "yyyy-MM-dd") + "T00:00:00Z");
            $(this.element.element).data("kendoDatePicker").value(value);
        } else {
            source.set(path, null);
            $(this.element.element).data("kendoDatePicker").value(null);
        }
    }
});

const signatureBinder = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);
    },
    refresh: function () {
        var value = this.bindings.signature.get();

        if (!value) {
            $(this.element).text("---");
            $(this.element).data("SignatureId", null);
        } else {
            $(this.element).text(ll("ViewSignature"));
            $(this.element).data("SignatureId", value);
        }
    }
});

const urlBinder = kendo.data.Binder.extend({
    init: function (element, bindings, options) {
        kendo.data.Binder.fn.init.call(this, element, bindings, options);
    },
    refresh: function () {
        var value: string = this.bindings.url.get();

        if (!value) {
            $(this.element).text("---");
            $(this.element).data("url", null);
        } else {
            // Split on the last pipe
            // Index0 is the label
            // Index1 is the url (which will never contain pipes)
            var splitUrl = value.splitOnLastInstanceOf("|");
            var label = splitUrl[0];
            var url = splitUrl[1];

            $(this.element).text(label);
            $(this.element).data("url", url);
        }
    }
});

// Might want to try to do these binders this way at some point:
// http://www.telerik.com/forums/typescript-definition-file-problems

var kendoDataBinders = (kendo.data as any).binders;
kendoDataBinders.url = urlBinder;
kendoDataBinders.signature = signatureBinder;
kendoDataBinders.customText = customTextBinder;
kendoDataBinders.widget.customText = customTextBinder;
kendoDataBinders.customTextAndTooltip = customTextAndTooltipBinder;
kendoDataBinders.widget.customTextAndTooltip = customTextAndTooltipBinder;
kendoDataBinders.booleanText = booleanTextBinder;
kendoDataBinders.currency = currencyBinder;
kendoDataBinders.percentage = percentageBinder;
kendoDataBinders.countText = countTextBinder;
kendoDataBinders.durationFromHours = durationFromHoursBinder;
kendoDataBinders.durationTimer = durationTimerBinder;
kendoDataBinders.tooltip = tooltipBinder;
kendoDataBinders.localizedText = localizedTextBinder;
kendoDataBinders.ll = localizedTextBinder;
kendoDataBinders.widget.dateTime = widgetDateTimeBinder;
kendoDataBinders.dateTime = dateTimeBinder;
kendoDataBinders.widget.date = dateBinder;
kendoDataBinders.widget.time = timeBinder;
kendoDataBinders.widget.absoluteTime = absoluteTimeBinder;
